import { noop } from 'lodash';
import * as React from 'react';

type ModalState = Record<string, boolean>;
type SetModalContextCallback = (prevState: ModalState) => ModalState;
interface IModalContext {
  modalState: ModalState;
  setModalState: (setStateCallback: SetModalContextCallback) => void;
}
// This context keeps track of the modals on the page
// and whether they are open or closed.
export const ModalContext = React.createContext<IModalContext>({
  modalState: {},
  setModalState: noop,
});

export const ModalContextProvider = ({
  children,
}: React.PropsWithChildren<Record<string, unknown>>) => {
  const [modalState, setModalState] = React.useState<Record<string, boolean>>(
    {}
  );

  const value = React.useMemo(
    () => ({ modalState, setModalState }),
    [modalState]
  );

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};
